import clsx from 'clsx'

import type { DialogProps } from './type'

import { CloseFilledIcon } from '@/components/icons/CloseFilled'
import { DialogBase, Icon, TextButton } from '@/components/ui'

import { variants } from './const'

export const Dialog = ({
  isOpen,
  title,
  variant = 'primary',
  initialFocus,
  children,
  size = 'base',
  onClose,
  className,
}: DialogProps) => {
  return (
    <DialogBase isOpen={isOpen} onClose={onClose} initialFocus={initialFocus}>
      <div
        className={clsx(
          'tw-mx-4 tw-my-8 tw-w-full tw-max-w-pcMax',
          'tw-rounded tw-bg-white tw-text-left tw-shadow-md',
          'tw-transform tw-overflow-hidden tw-transition-all',
          size === 'base' ? 'lg:tw-max-w-sm' : 'lg:tw-w-pcMax'
        )}
      >
        <div
          className={clsx(
            'tw-w-full tw-px-2',
            'tw-grid tw-grid-cols-8',
            'tw-h-14 tw-items-center tw-justify-end',
            'tw-text-sm tw-font-bold tw-text-white',
            variants[variant]
          )}
          style={{ direction: 'rtl' }}
        >
          <div className={clsx('tw-text-right', 'tw-col-span-1')}>
            {onClose && (
              <TextButton onClick={onClose}>
                <Icon icon={CloseFilledIcon} size={'md'} color={'white'} />
              </TextButton>
            )}
          </div>
          <div className={clsx('tw-w-full tw-text-center', 'tw-col-span-6')}>
            {title}
          </div>
        </div>
        <div className={clsx('tw-mt-2 tw-p-2', className)}>{children}</div>
      </div>
    </DialogBase>
  )
}
